exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  padding: 40px;\n  text-align: center; }\n  .loading-container mat-spinner {\n    margin-bottom: 20px; }\n\n.comparison-container .row {\n  margin-bottom: 20px; }\n\n.comparison-container h3 {\n  margin-bottom: 15px;\n  font-size: 18px;\n  font-weight: 500; }\n\n.comparison-container .comparison-row {\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 8px;\n  padding: 8px;\n  border-left: 3px solid transparent;\n  transition: background-color 0.2s; }\n  .comparison-container .comparison-row.different {\n    background-color: #fff3cd;\n    border-left-color: #ffc107; }\n  .comparison-container .comparison-row .col-md-6 {\n    -ms-flex: 1;\n        flex: 1;\n    padding: 0 15px;\n    word-break: break-word; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/CustomersModule/CustomerAresComparisonDialogComponent/customer-ares-comparison.dialog.component.scss
// module id = ../../../../../src/CustomersModule/CustomerAresComparisonDialogComponent/customer-ares-comparison.dialog.component.scss
// module chunks = main